// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"brand-image-component_linkContainer__2bvjE","brandImageContainer":"brand-image-component_brandImageContainer__2c6U9"};